import { useCallback } from 'react';
import { CONFERENCE_BLANK_DIMENSIONS, CONFERENCE_TYPE_VIDEO } from 'utils/constants';
import Loading from 'components/spinner/Loading'

type UseCreateConferenceParams = {
  createConference: (payload: {
    roomId: string;
    type: string;
    conferenceType: string;
  }) => Promise<any>;
  createMeetingConversation: (payload: {
    members: any[];
    parentRoom: string | null;
  }) => Promise<any>;
  isElectron: boolean;
  windowApi?: any;
  closeConferenceModal?: () => void;
};

export const useCreateConference = ({
  createConference,
  createMeetingConversation,
  isElectron,
  windowApi,
  closeConferenceModal,
}: UseCreateConferenceParams) => {
  const handleCreateConference = useCallback(
    async (conferenceType: string, members: any, parentRoom: string | null) => {
      try {
        Loading.ref.show();





        const meetingRoomResponse = await createMeetingConversation({
          members: members || [],
          parentRoom
        });
        const { _id: chatRoomId } = meetingRoomResponse?.data?.data || {};

        const data =
          (await createConference({
            roomId: chatRoomId,
            type: 'single',
            conferenceType,
          })) || {
            status: 'pending',
            data: { data: {} },
          };

        if (data.status === 'rejected') {
          return;
        }

        const { title, url } = data.data || {};

        if (!url) {
          return;
        }


        const parts = new URL(url).pathname.split('/');
        const participantToken = parts.pop();
        const meetingId = parts.pop();


        if (!chatRoomId || !meetingId || !participantToken) {
          return;
        }

        const newUrl = `/video-conference/${chatRoomId}/${meetingId}/${participantToken}`;

        if (isElectron && windowApi) {
          const notifyType =
            conferenceType === CONFERENCE_TYPE_VIDEO
              ? 'videoConference'
              : 'audioConference';

          windowApi.send('callSelfBtn', {
            type: notifyType,
            title: 'selfCall',
            msg: title,
            url,
          });
        } else {
          window.open(newUrl, '', CONFERENCE_BLANK_DIMENSIONS);
        }
      } catch (error) {
        console.error('handleCreateConference error:', error);
      } finally {
        closeConferenceModal?.();
        Loading.ref.hide();
      }
    },
    [
      createConference,
      createMeetingConversation,
      isElectron,
      windowApi,
      closeConferenceModal,
    ]
  );

  return {
    handleCreateConference,
  };
};
